import React from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import NotFound from './pages/NotFound';
import SearchForm from './pages/SearchForm';
import SearchResults from './pages/SearchResults';

const App : React.FC = () => {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/" exact component={SearchForm}/>
                <Route path="/search" component={SearchResults}/>
                <Route path="*" component={NotFound}/>
            </Switch>
        </BrowserRouter>
    );
};

export default App;
